@if (information) {
  <div
    [class.warning-container]="information.warning_header || information.warning_text"
  >
    @if (information.ingress) {
      <h2>
        {{ information.ingress | translate:{objectType: information.title | translate} }}
      </h2>
    }

    @if (information.content) {
      <p>
        {{ information.content | translate }}
      </p>
    }
    @if (information.warning_header) {
      @if (information.warning_icon) {
        <mat-icon class="warning-icon" aria-hidden="true">
          {{ information.warning_icon }}
        </mat-icon>
      }
      <span class="warning-header">
        {{ information.warning_header | translate }}:
      </span>
    }
    @if (information.warning_text) {
      <p class="warning-content">
        {{ information.warning_text | translate }}
      </p>
    }
  </div>
}
